'use strict';
const CONST = require('plugin_frontend_core/constants');

$(function () {
    // Trigger 'cart:view' custom event for GTM tracking if there are product line items. It has to be delayed so that custom event listener is registered before the event is fired
    setTimeout(function () {
        const $productLineItems = $('[data-js="product-line-item"]');
        $(document).trigger(CONST.events.cartViewPage, { $items: $productLineItems });
    }, 100);

    // Track product line item click and trigger 'product:tileClick' custom event
    $(document).on('click', '[data-js="product-line-item-product-link"]', function () {
        const $productLineItem = $(this).parents('[data-js="product-line-item"]');
        $(document).trigger(CONST.events.productTileClick, { $productTileWrapper: $productLineItem });
    });
});
